export const RecaptchaError = 'reCaptcha' as const;

/**
 * The error codes returned by the ReCaptcha API.
 */
export enum ReCaptchaErrorCode {
  MissingInputSecret = 'missing-input-secret',
  InvalidInputSecret = 'invalid-input-secret',
  MissingInputResponse = 'missing-input-response',
  InvalidInputResponse = 'invalid-input-response',
  BadRequest = 'bad-request',
  TimeoutOrDuplicate = 'timeout-or-duplicate',
}

/**
 * ReCaptcha error codes that could be related to the user's input.
 */
export const userCaptchaErrors = [
  ReCaptchaErrorCode.MissingInputResponse,
  ReCaptchaErrorCode.InvalidInputResponse,
  ReCaptchaErrorCode.TimeoutOrDuplicate,
];

/**
 * ReCaptcha error codes that are related to the server.
 */
export const serverCaptchaErrors = [
  ReCaptchaErrorCode.MissingInputResponse,
  ReCaptchaErrorCode.InvalidInputResponse,
  ReCaptchaErrorCode.MissingInputSecret,
  ReCaptchaErrorCode.InvalidInputSecret,
  ReCaptchaErrorCode.BadRequest,
];
